


































































































































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import { harvestStatus } from '@/app/model/store/domain/const'
import Local from '@/app/module/local'
import FieldOrderDownloadApi from '@/app/model/api/fieldOrderDownloadApi'
import CommonClass from '@/app/module/common'
import DateClass from '@/app/module/date'

@Component
export default class OrderSearch extends Vue {
  public checkboxes: {[key: string]: string|boolean}[] = [
    { label: '未指示', value: 'notDirected', checked: true },
    { label: '保留', value: 'onHold', checked: true },
    { label: '中止', value: 'chancel', checked: true },
    { label: '収穫途上', value: 'harvesting', checked: true },
    { label: '収穫指示', value: 'harvesteInstructions', checked: true },
    { label: '収穫済み', value: 'harvested', checked: true }
  ]
  private seasonBoxes: {[key: string]: string|boolean|number}[] = [
    { label: '表作付け', value: 1, checked: true },
    { label: '裏作付け', value: 2, checked: true }
  ]
  private statusSelected: number[] = []
  private yearSelected: number|null = null
  private seasonSelected: number[] = []
  private varietySelected: string|null = null
  private gradeSelected: string|null = null
  private yearList: number[] = []
  private varietyList: string[] = []
  private gradeList: string[] = []
  public requesting: boolean = false
  private searchText: string = ''

  @Prop() private orderData!: any

  private get props (): any {
    return this.orderData
  }
  @Watch('props')
  onYearChange (newValue: string) {
    this.orderData = newValue
    // this.createRefineData()
  }

  created () {
    /* 現在の年とシーズンを追加 */
    this.yearSelected = new Date().getFullYear()

    /* yearの配列を作成 */
    let endYear = new Date().getFullYear() + 1
    const constantValue = JSON.parse(Local.getConstantValue()!)
    let minPlantYear = constantValue.min_plant_year
    if (minPlantYear === null) {
      minPlantYear = new Date().getFullYear()
    }
    for (let i = minPlantYear; i <= endYear; i++) {
      this.yearList.unshift(i)
    }

    /* 品種の配列を作成 */
    this.varietyList = JSON.parse(Local.getVarietiesData()!)

    /* 等級の配列を作成 */
    this.gradeList = constantValue.grades

    this.setStatus()
    this.setSeason()
    this.setOrderData()
  }

  private setStatus () {
    this.statusSelected = []

    for (var i in this.checkboxes) {
      if (this.checkboxes[i].checked) {
        switch (this.checkboxes[i].value) {
          case 'notDirected':
            this.statusSelected.push(harvestStatus.NOT_DIRECTED)
            break

          case 'onHold':
            this.statusSelected.push(harvestStatus.ON_HOLD)
            break

          case 'chancel':
            this.statusSelected.push(harvestStatus.CHANCEL)
            break

          case 'harvesteInstructions':
            this.statusSelected.push(harvestStatus.HARVESTE_INSTRUCTIONS)
            break

          case 'harvesting':
            this.statusSelected.push(harvestStatus.HARVESTING)
            break

          case 'harvested':
            this.statusSelected.push(harvestStatus.HARVESTED)
            break

          default:
            break
        }
      }
    }
  }

  private setSeason () {
    this.seasonSelected = []

    for (var i in this.seasonBoxes) {
      if (this.seasonBoxes[i].checked) {
        switch (this.seasonBoxes[i].value) {
          case 1:
            this.seasonSelected.push(1)
            break

          case 2:
            this.seasonSelected.push(2)
            break

          default:
            break
        }
      }
    }
  }

  private setOrderData () {
    this.$store.commit('fieldOrderState/setSelectedYear', this.yearSelected)
    this.$store.commit('fieldOrderState/setSelectedSeason', this.seasonSelected)
    this.$store.commit('fieldOrderState/setSelectedStatus', this.statusSelected)
    this.$store.commit('fieldOrderState/setSelectedVariety', this.varietySelected)
    this.$store.commit('fieldOrderState/setSelectedGrade', this.gradeSelected)
    this.$store.commit('fieldOrderState/setWord', this.searchText)
  }

  private changeOrderData () {
    this.setStatus()
    this.setSeason()

    this.$store.commit('fieldOrderState/setSelectedYear', this.yearSelected)
    this.$store.commit('fieldOrderState/setSelectedSeason', this.seasonSelected)
    this.$store.commit('fieldOrderState/setSelectedStatus', this.statusSelected)
    this.$store.commit('fieldOrderState/setSelectedVariety', this.varietySelected)
    this.$store.commit('fieldOrderState/setSelectedGrade', this.gradeSelected)
    this.$store.commit('fieldOrderState/setWord', this.searchText)

    this.$emit('update-order-list')
  }

  private resetOrderData () {
    /* セレクト初期化 */
    this.yearSelected = new Date().getFullYear()

    /* シーズン初期化 */
    this.seasonBoxes[0].checked = true
    this.seasonBoxes[1].checked = true

    this.setSeason()

    this.$store.commit('fieldOrderState/setSelectedYear', this.yearSelected)
    this.$store.commit('fieldOrderState/setSelectedSeason', this.seasonSelected)
    this.checkboxes = [
      { label: '未指示', value: 'notDirected', checked: true },
      { label: '保留', value: 'onHold', checked: true },
      { label: '中止', value: 'chancel', checked: true },
      { label: '収穫途上', value: 'harvesting', checked: true },
      { label: '収穫指示', value: 'harvesteInstructions', checked: true },
      { label: '収穫済み', value: 'harvested', checked: true }
    ]
    this.setStatus()
    this.$store.commit('fieldOrderState/setSelectedStatus', this.statusSelected)

    /* 品種とグレード初期化 */
    this.varietySelected = null
    this.gradeSelected = null
    this.searchText = ''

    this.$store.commit('fieldOrderState/setSelectedVariety', this.varietySelected)
    this.$store.commit('fieldOrderState/setSelectedGrade', this.gradeSelected)
    this.$store.commit('fieldOrderState/setWord', this.searchText)

    this.$emit('reset-order-list')
  }

  private openOrderModal () {
    this.$emit('show-modal')
  }

  private getSeasonName () {
    let seasonLabel: any = ''
    for (let i in this.seasonBoxes) {
      if (this.seasonBoxes[i].checked) {
        if (seasonLabel === '') {
          seasonLabel = this.seasonBoxes[i].label
        } else {
          seasonLabel = seasonLabel + this.seasonBoxes[i].label
        }
      }
    }
    return seasonLabel
  }

  private fieldOrderDownload () {
    (async () => {
      this.requesting = true
      this.setStatus()
      this.setSeason()

      const body: any = {}

      if (this.searchText !== '') {
        body.word = this.searchText
      }
      if (this.varietySelected !== null) {
        body.variety_id = this.varietySelected
      }
      if (this.gradeSelected !== null) {
        body.grade_id = this.gradeSelected
      }
      if (this.yearSelected !== null) {
        body.year = this.yearSelected
      }
      if (this.seasonSelected.length !== 0) {
        body.season = this.seasonSelected
      }
      if (this.statusSelected.length !== 0) {
        body.harvest_status = this.statusSelected
      }

      const result: any = await FieldOrderDownloadApi.doFieldOrderDownload(body)

      if (typeof result === 'string') {
        let link = document.createElement('a')
        const today = DateClass.dateToStringYmd(new Date(), 'yyyyMMdd')
        const year = this.yearSelected === null ? '' : '_' + this.yearSelected
        const season = this.seasonSelected.length === 0 ? '' : '_' + this.getSeasonName()
        document.body.appendChild(link)
        link.href = result
        link.download = '分析用データ_' + today + year + season + '.csv'
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(result)
        this.requesting = false
      } else {
        if (result.getPayload().status_code === '400') {
          const message = '分析用データ出力ができませんでした。\n対象となる作付けが100件以内になるように検索条件を変更して、再度お試しください。'
          Vue.prototype.$alert.toast({ text: message, type: 2 })
        } else {
          const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
        }
        this.$emit('show-loading', false)
        this.requesting = false
      }
    })()
  }
}
